const FractionSimpleLatex = ({value: {numerator, denominator, whole}}) => {
   return `${whole ? whole : ''}\\frac{${numerator}}{${denominator}}`;
};

export default FractionSimpleLatex;
